import type { SearchCriteria } from '@awazevr/mfe-common.types-and-mocks.site-search-service'

/**
 * `useExpandedCoordinates` arrives from URL params as a string, so a truthiness
 * check would treat `'false'` as expanded. Match `true` / `'true'` explicitly.
 */
export const isExpandedCoordinatesSearch = (
  value: boolean | string | undefined,
): boolean => value === true || value === 'true'

/** The criteria are the expanded-polygon ("View more") search. */
export const isExpandedCoordinatesCriteria = (
  criteria: SearchCriteria,
): boolean =>
  isExpandedCoordinatesSearch(
    (criteria as { useExpandedCoordinates?: boolean | string })
      .useExpandedCoordinates,
  )
